import { render, staticRenderFns } from "./AddNewCommissionInvoice.vue?vue&type=template&id=5790b65e&scoped=true&"
import script from "./AddNewCommissionInvoice.vue?vue&type=script&lang=js&"
export * from "./AddNewCommissionInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCommissionInvoice.vue?vue&type=style&index=0&id=5790b65e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5790b65e",
  null
  
)

export default component.exports